<template>
<!-- 合作案例 -->
  <div class="case">
    <div class="item banner" >
      <img class="item-img"  src="https://qiniu.swarma.org/business/jpg/case/banner.png" alt="集智学园">
    </div>
    <!-- 合作案例 -->
    <section class="section-item" :style="i === 4 || i == 2? 'height: 750px' : i == 3 || i === 6 ? 'height: 800px' : ''" v-for="(item, i) in caseList" :key="i">
      <!-- <h1>课程特色</h1> -->
      <img :src="item.bg_pic" alt="集智学园" v-if="item.bg_pic">
      <div class="section-item-content" >
        <img class="section-item-content-img" :src="item.pic" alt="集智学园">
        <div class="section-item-content-text">
          <li class="text-item" v-for="(i) in item.content" :key="i.title">
            <span class="text-item-title">{{i.title}}：</span>
            <span class="text-item-content">{{i.text}}</span>
          </li>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'case',
  data () {
    return {
      // bannerList: [{
      //   // title: '集智学园',
      //   // content: '配色色系最好和集智学园logo色系一致配色色系最好和集智学园logo色系一致配色色系最好和集智学园logo色系一致配色色系最好和集智学园logo色系一致配色色系最好和集智学园logo色系一致配色色系最好和集智学园logo色系一致',
      //   src: 'https://qiniu.swarma.org/business/jpg/case/banner.png'
      // }],
      caseList: [{
        bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo1.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_1.png',
        content: [{
          title: '公司介绍',
          text: '奥雅纳工程顾问于1946年4月1日在英国伦敦成立，是全球最大、最成功的工程顾问公司之一。奥雅纳在大中华地区已有35多年的发展历史，参与设计项目有著名的鸟巢、水立方、北京中央电视台新台址、2010年上海世博会场馆等。'
        }, {
          title: '合作课程',
          text: '《Python数据科学与机器学习》'
        }, {
          title: '主要内容',
          text: '主要内容：如何用Python操作数据、什么是数据科学？什么是机器学习？如何将数据科学与机器学习应用在企业中的具体案例。'
        }, {
          title: '讲    师',
          text: '尹相志'
        }, {
          title: '时    间',
          text: '2019年3月'
        }]
      }, {
        // bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo2.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_2.png',
        content: [{
          title: '公司介绍',
          text: '金风科技成立于1998年，是国内最大的风力发电设备研发和制造商。是中国新能源发展的亲历者与创新的推动者，多次入选“全球最具创新能力企业50强”，荣登2016年度“全球挑战者”百强榜。'
        }, {
          title: '合作课程',
          text: '《Python数据科学与机器学习》'
        }, {
          title: '主要内容',
          text: '什么是数据科学？什么是机器学习？如何将数据科学与机器学习应用在企业中， 数据科学的方法论(建模/评估模型)。'
        }, {
          title: '讲    师',
          text: '尹相志'
        }, {
          title: '时    间',
          text: '2019年9月14日'
        }]
      }, {
        bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo2.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_3.png',
        content: [{
          title: '公司介绍',
          text: '晨兴资本是中国最早从事早期风险投资的机构之一，目前管理四期美元基金及一期人民币基金，所管理资金规模约十七亿美元，出资人来自国际知名主权基金、家族基金、母基金及大学基金会等。成功案例包括：搜狐，携程，第九城市，正保远程教育，迅雷，凤凰新媒体，UCWeb，YY，小米科技等。'
        }, {
          title: '合作课程',
          text: '《人工智能与创业》'
        }, {
          title: '主要内容',
          text: '介绍人工智能的发展历史，以及人工智能的三大学派思想：符号学派、行为学派和链接学派；人工智能时代的创业趋势如何？人工智能创业的方法论为何？特别针对人工智能的人才挖掘与培养等问题展开详细讨论。'
        }, {
          title: '讲    师',
          text: '张江'
        }, {
          title: '时    间',
          text: '2017年3月15日'
        }]
      }, {
        //  bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo2.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_4.png',
        content: [{
          title: '公司介绍',
          text: '“百词斩”的公司名称是成都超有爱科技有限公司，成立于 2012 年。产品有 App “百词斩"以及“薄荷阅读”、“番茄英语”、“蛋糕英语”、“芝士派” 等其他英语细分学习领域产品，其中 App “百词斩”的用户已过八千万，领先目前其他在线教育创业公司。配合经纬中国 A 轮、中国文化产业投资基金 B 轮、红杉资本 C 轮、腾讯 D 轮投资，目前公司正稳定而快速的发展中。'
        }, {
          title: '合作课程',
          text: '《21世纪的复杂性科学》'
        }, {
          title: '主要内容',
          text: '介绍什么是复杂系统，什么是复杂性科学，以及它的发展历史脉络如何，对企业的发展有何帮助，如何运用复杂性思维进行企业管理？为什么人工智能时代更加需要复杂性思维？针对成都超有爱公司，具体如何利用复杂性理论指导其进一步成长、壮大。'
        }, {
          title: '讲    师',
          text: '张江'
        }, {
          title: '时    间',
          text: '2017年9月13日'
        }]
      }, {
        bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo3.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_5.png',
        content: [{
          title: '公司介绍',
          text: '图灵机器人是以语义技术为核心驱动力的人工智能公司，致力于“让机器理解世界”，产品服务包括机器人开放平台、机器人OS和场景方案。通过图灵机器人，开发者和厂商能够以高效的方式创建专属的聊天机器人、客服机器人、领域对话问答机器人、儿童/服务机器人等。'
        }, {
          title: '合作课程',
          text: '《系统科学&复杂性思维》'
        }, {
          title: '主要内容',
          text: '介绍什么是复杂性科学，它的发展历史脉络以及前沿进展如何，人工智能的历史发展概况以及不同学派体系。特别针对如何运用复杂性思维设计智能机器人，以及多主体智能等相关内容展开深入讨论。'
        }, {
          title: '讲    师',
          text: '张江'
        }, {
          title: '时    间',
          text: '2016年5月6日'
        }]
      }, {
        // bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo3.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_6.png',
        content: [{
          title: '公司介绍',
          text: '锋创科技园隶属于锋创科技发展（北京）有限公司，是北京知名的互联网创新型商务社区。园区建筑面积16.7万平方米含总部办公、小企业办公、众创空间、商务配套共计32栋楼。聚集近400家中小企业，5000余位职业精英，拥有央企、上市公司、优客工场、众创空间多样化互联网技术和互联网服务型公司与机构。'
        }, {
          title: '合作课程',
          text: '《AI视野—迎接AI时代》'
        }, {
          title: '主要内容',
          text: '人工智能的发展历史；什么是机器学习思维；如何建立数据科学到人工智能的思维范式；企业应在人工智能时代如何进行转型。'
        }, {
          title: '讲    师',
          text: '李子青、徐飞玉、尹相志、张江'
        }, {
          title: '时    间',
          text: '2017年5月20日'
        }]
      }, {
        bg_pic: 'https://qiniu.swarma.org/business/jpg/case/bg_hezuo4.png',
        pic: 'https://qiniu.swarma.org/business/jpg/case/logo_hezuo_7.png',
        content: [{
          title: '公司介绍',
          text: '深圳市城市规划设计研究院(深规院)是专注于创造和务实解决城市问题的规划咨询研究与设计机构，擅长以多学科综合规划的方法，应对城市发展过程中出现的复杂问题。1990年成立至今，在深圳以及国内外200多个地区完成了3500多个项目，涉及宏观区域研究、城市综合发展咨询、规划与城市设计、交通与市政基础设施、低碳生态技术研究与应用、地区开发政策等多个领域。'
        }, {
          title: '合作课程',
          text: '《拥抱前沿：人工智能技术培训》'
        }, {
          title: '主要内容',
          text: '介绍了什么是人工智能？人工智能是怎样影响和改变一个行业的发展方向（AI+）？人工智能平台是如何发展、又是如何应用于实践？以及人工智能在智慧城市建设中的应用。帮助深圳城市规划设计研究院建立AI技术转型所需的思维观念、能力和关键技术。'
        }, {
          title: '讲    师',
          text: '张江、王雄、李睿琪'
        }, {
          title: '时    间',
          text: '2019年1月3日-1月5日'
        }, {
          title: '地    点',
          text: '深圳市福田区建艺大厦'
        }]
      }]
    }
  }
}
</script>
<style lang="less" scoped>
.banner-item {
  position: relative;
  .item-img {
    width: 100%;
    margin: 0;
    display: inherit;
  }
  .item-text {
    position: absolute;
    left: 20%;
    color: #fff;
    top: 50%;
    font-size: 14px;
    transform: translateY(-50%);
    .item-title {
      font-weight: normal;
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      margin: 10px 0;
    }
    .item-content {
      // top: 70px;
      width: 40%;
    }
  }
}
.section-item {
  min-height: 500px;
  position: relative;
  & > img {
    height: 100%;
    display: inherit;
  }
  .section-item-content {
    padding: 0 10%;
    position: absolute;
    left: 0;
    top: 50%;
    text-align: center;
    width: 100%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    box-sizing: border-box;
    .section-item-content-img {
      position: absolute;
      top: 50%;
      transform: translate(-50%,-50%);
      left: 25%;
    }
    .section-item-content-text {
      display: inline-block;
      // width: 50%;
      text-align: left;
      margin-left: 50%;
      color: #333;
      font-size: 14px;
      line-height: 20px;
      list-style: none;
      .text-item {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        margin: 10px 0;
        .text-item-title {
          font-weight: bold;
          top: 3px;
          position: relative;
        }
        .text-item-content {
          width: calc(100% - 70px);
           color: #393940;
           line-height: 27px;
        }
      }
    }
  }
}
// ipad
@media screen and(max-width: 769px) {
  .section-item {
     min-height: 600px;
    .section-item-content {
      text-align: left;
      .section-item-content-img {
        position: absolute;
        width: 20%;
        top: -60px;
        left: 50%;
      }
      .section-item-content-text {
        margin-left: 0;
      }
    }
  }
}
// 移动
@media screen and(max-width: 414px) {
  .section-item {
    min-height: 600px;
    &.section-item:nth-child(6){
      min-height: 700px;
    }
    .section-item-content {
      .section-item-content-img {
        top: -30px;
        width: 33%;
      }
      .section-item-content-text {
        font-size: 12px;
        .text-item-content{
          line-height: 23px;
        }
      }
    }
  }
}
</style>
